import { Component } from "react";
import { LogoSplash } from "@/components/site/LogoSplash";

export class ErrorBoundary extends Component {
  state = { error: null, tries: 0 };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidMount() {
    setTimeout(() => sessionStorage.removeItem("dnn_auto_reload"), 10000);
  }

  componentDidCatch(error, info) {
    console.error("App error:", error);
    const body = { message: String(error?.message || error).slice(0, 500), stack: String(error?.stack || "").slice(0, 2000),
      component: String(info?.componentStack || "").slice(0, 1500), url: window.location.href, ua: navigator.userAgent };
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-errors`, { method: "POST", keepalive: true, headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }).catch(() => {});
    if (this.state.tries < 1) {
      setTimeout(() => this.setState({ error: null, tries: 1 }), 300);
    } else if (!sessionStorage.getItem("dnn_auto_reload")) {
      sessionStorage.setItem("dnn_auto_reload", "1");
      setTimeout(this.reset, 300);
    }
  }

  reset = async () => {
    try {
      const regs = (await navigator.serviceWorker?.getRegistrations?.()) || [];
      await Promise.all(regs.map((r) => r.unregister()));
      const keys = (await window.caches?.keys?.()) || [];
      await Promise.all(keys.map((k) => caches.delete(k)));
    } catch (e) {}
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;
    return <LogoSplash onClick={this.reset} testId="app-error-screen" />;
  }
}
